import React, { useContext, useEffect, useState } from 'react';

import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';

import { AppContext } from '../../../../context';

import Style from './Assessment.module.css';

import { getAssessmentQues, submitAssessment } from '../../../../redux/actions/aeAssessment';
import { applyJob } from '../../../../redux/actions/aeJobs';
import { getProfile } from '../../../../redux/actions/aeMyProfile';

import { Button, Loader } from '../../../atoms';
import { InputCard } from '../../../molecules';

import { assessmentValidator } from './utils';
import { isEmpty } from '../../../../utils/generic';
import { pushEventInLoggy } from '../../../../utils/loggy';

function Assessment({ setSection, work, education, resume, professional, currentJob, fresher }) {
  const isFetching_ques = useSelector((state) => state?.assessment_ques?.isFetching);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { job_details, my_profile } = useSelector(({ my_profile, job_details }) => ({ my_profile, job_details }));
  const { isMobile } = useContext(AppContext);
  const dispatch = useDispatch();

  const { assessment_ques } = useSelector((state) => state);

  // const [answer, setAnswer] = useState(new Array(assessment_ques?.data?.data?.assessment_configs?.[0]?.questions?.length));

  const [answer, setAnswer] = useState(new Array(assessment_ques?.data?.data?.assessment_configs?.[0]?.questions?.length));
  const [error, setError] = useState({});
  const assessment_configuration_id = assessment_ques?.data?.data?.assessment_configs?.[0]?.id;
  const role_code = job_details?.data?.data?.role_code;
  const list = assessment_ques?.data?.data?.assessment_configs?.[0]?.questions;
  const QuestionsAsc = list ? [...list].sort((a, b) => a.sequence - b.sequence) : [];

  // getting assessment questions

  useEffect(() => {
    if (!isEmpty(job_details?.data?.data?.role_code)) {
      dispatch(getAssessmentQues(job_details?.data?.data?.role_code));
    }
  }, []);

  // creating resp array

  useEffect(() => {
    const arr = [];

    for (let i = 0; i < assessment_ques?.data?.data?.assessment_configs?.[0]?.questions?.length; i++) {
      arr.push('');
    }

    setAnswer(arr);
  }, [assessment_ques]);

  const handleBack = () => {
    setSection({ value: 'Professional Details', id: 3 });
  };

  // function to update the profile and get updated profile after form submission

  // const handleUpdateProfile = () => {
  //   let body;

  //   if (fresher) {
  //     body = {
  //       candidate: {
  //         resume_link: resumeLink,
  //         resume,
  //         expected_ctc: {
  //           esops: professional?.values?.expected_esops ? professional?.values?.expected_esops : 0,
  //           fixed: professional?.values?.expected_fixed,
  //           total: Number(professional?.values.expected_fixed || 0) + Number(professional?.values.expected_esops || 0) + Number(professional?.values.expected_variable || 0),
  //           variable: professional?.values?.expected_variable ? professional?.values?.expected_variable : 0
  //         },
  //         open_for_locations: professional?.arr,
  //         education_details: education?.education_details
  //       }
  //     };
  //   } else {
  //     body = {
  //       candidate: {
  //         resume_link: resumeLink,
  //         resume,
  //         notice_period_in_months: professional?.values?.months,
  //         current_ctc: {
  //           esops: professional?.values?.current_esops ? professional?.values?.current_esops : 0,
  //           fixed: professional?.values?.current_fixed,
  //           total: Number(professional?.values.current_fixed || 0) + Number(professional?.values.current_esops || 0) + Number(professional?.values.current_variable || 0),
  //           variable: professional?.values?.current_variable ? professional?.values?.current_variable : 0
  //         },
  //         expected_ctc: {
  //           esops: professional?.values?.expected_esops ? professional?.values?.expected_esops : 0,
  //           fixed: professional?.values?.expected_fixed,
  //           total: Number(professional?.values.expected_fixed || 0) + Number(professional?.values.expected_esops || 0) + Number(professional?.values.expected_variable || 0),
  //           variable: professional?.values?.expected_variable ? professional?.values?.expected_variable : 0
  //         },
  //         open_for_locations: professional?.arr,
  //         education_details: education?.education_details,
  //         experience_details: work?.experience_details,
  //         experience_in_years: parsedData?.totalYearsExperience,
  //         current_role: currentJob?.current_role,
  //         current_employer: currentJob?.current_employer
  //       }
  //     };
  //   }

  //   dispatch(updateProfile(body))
  //     .then(() => {
  //       dispatch(getProfile())
  //         .then(() => {
  //           // profile successfully fetched
  //         })
  //         .catch(() => {
  //           // profile fetch failed
  //         });
  //     })
  //     .catch(() => {
  //       // profile updation failed
  //     });

  //   setSection({ value: 'Submit', id: 5 });
  // };

  // function to submit assessment and then call profile updation

  const handleAssessmentSubmit = (application_id) => {
    if (QuestionsAsc?.length !== 0) {
      const resp = QuestionsAsc?.map((item, i) => {
        let updatedVal = answer[i];

        if (item.render_type === 'multi_select_dropdown') {
          updatedVal = [];
          const oldAnswer = answer[i] || [];

          oldAnswer.map((item) => updatedVal.push(item?.value));
        } else if (item.render_type === 'single_select_dropdown') {
          updatedVal = answer[i]?.value;
        }

        return { question_text: item?.question_text, render_type: item?.render_type, attribute_type: item?.attribute_type, response: updatedVal || '' };
      });

      dispatch(
        submitAssessment({
          assessment_response: {
            assessment_configuration_id: assessment_configuration_id,
            job_application_id: application_id,
            name: role_code,
            responses: resp
          }
        })
      );
    }

    dispatch(getProfile())
      .then(() => {
        // profile successfully fetched

        setIsSubmitting(false);
      })
      .catch(() => {
        // profile fetch failed

        setIsSubmitting(false);
      });
    setSection({ value: 'Submit', id: 5 });
  };

  // function to submit application and then call assessment submission

  const handleApplicationSubmit = () => {
    setIsSubmitting(true);
    let body;

    if (fresher) {
      body = {
        application: {
          resume_id: resume?.id,
          expected_ctc: {
            esops: professional?.values?.expected_esops?.trim() ? String(professional?.values?.expected_esops)?.trim() : 0,
            fixed: String(professional?.values?.expected_fixed)?.trim(),
            total:
              Number(String(professional?.values?.expected_fixed)?.trim() || 0) +
              Number(String(professional?.values?.expected_esops)?.trim() || 0) +
              Number(String(professional?.values?.expected_variable)?.trim() || 0),
            variable: professional?.values?.expected_variable ? String(professional?.values?.expected_variable)?.trim() : 0
          },
          open_for_locations: professional?.arr,
          education_details: education?.education_details
        }
      };
    } else {
      body = {
        application: {
          resume_id: resume?.id,
          notice_period_in_days: String(professional?.values?.notice_period_in_days)?.trim(),
          experience_in_years: String(professional?.values?.experience_in_years)?.trim(),
          current_ctc: {
            esops: professional?.values?.current_esops ? String(professional?.values?.current_esops)?.trim() : 0,
            fixed: String(professional?.values?.current_fixed)?.trim(),
            total:
              Number(String(professional?.values?.current_fixed)?.trim() || 0) +
              Number(String(professional?.values?.current_esops)?.trim() || 0) +
              Number(String(professional?.values?.current_variable)?.trim() || 0),
            variable: professional?.values?.current_variable ? String(professional?.values?.current_variable)?.trim() : 0
          },
          expected_ctc: {
            esops: professional?.values?.expected_esops ? String(professional?.values?.expected_esops)?.trim() : 0,
            fixed: String(professional?.values?.expected_fixed)?.trim(),
            total:
              Number(String(professional?.values?.expected_fixed)?.trim() || 0) +
              Number(String(professional?.values?.expected_esops)?.trim() || 0) +
              Number(String(professional?.values?.expected_variable)?.trim() || 0),
            variable: professional?.values?.expected_variable ? String(professional?.values?.expected_variable)?.trim() : 0
          },
          open_for_locations: professional?.arr,
          education_details: education?.education_details,
          experience_details: work?.experience_details,
          current_role: currentJob?.current_role,
          current_employer: currentJob?.current_employer
        }
      };
    }

    const error = assessmentValidator(QuestionsAsc, answer);

    if (!isEmpty(error)) {
      setError(error);

      return;
    }

    dispatch(applyJob(job_details?.data?.data?.id, body))
      .then((data) => {
        pushEventInLoggy(
          {
            event: 'AEx_Application_Created',
            other_properties: {
              created_at: format(new Date(), 'yyyy-MM-dd, HH:mm:ss'),
              candidate_zoho_id: my_profile?.data?.data?.id,
              posting_title: job_details?.data?.data?.job_role_name,
              job_role_code: job_details?.data?.data?.role_code,
              first_name: my_profile?.data?.data?.first_name,
              last_name: my_profile?.data?.data?.last_name,
              mobile_number: my_profile?.data?.data?.mobile_number,
              email: my_profile?.data?.data?.email
            }
          },
          my_profile
        );

        // submit assessment

        handleAssessmentSubmit(data?.data?.id);
      })
      .catch(() => {
        // application submission failed
      });
  };

  return (
    <div>
      <div className={Style.BasicDetailsEdit}>{!isMobile ? <div className={`${Style.sectionHeading} padding32T`}>Assessment</div> : null}</div>
      <div>
        {isFetching_ques ? (
          <div className='center-x-y p-t-b-100'>
            <Loader size='md' type='text-light' />
          </div>
        ) : (
          <div className={`${Style.BasicDetailsEdit} ${Style.questionArea} `}>
            {(QuestionsAsc || [])?.map((item, i) => (
              <InputCard
                errors={error[item.sequence - 1] || []}
                input_structure={item.input_structure || 'single'}
                ismandatory={item.ismandatory}
                key={item.sequence}
                name={item.question_text}
                number={i}
                options={item.options}
                setFieldValue={(_, value) =>
                  setAnswer((prevState) =>
                    prevState.map((ele, index) => {
                      if (error[item.sequence - 1]) {
                        setError((state) => ({ ...state, [item.sequence - 1]: '' }));
                      }

                      return index === i ? value : ele;
                    })
                  )
                }
                text={String(item.sequence)}
                type={item.render_type}
                values={answer[i]}
              />
            ))}
          </div>
        )}
      </div>
      <div className='m-t-30'>
        <div className={` ${Style.BasicDetailsEdit} border-top-grey row margin-0 `}>
          <div className='col-6 padding0L padding8T'>
            <Button className='general-outline-style padding32L padding32R pd-t-b-9' onClick={handleBack} type='button'>
              Back
            </Button>
          </div>
          <div className='col-6 flexStyleEnd padding0R padding8T'>
            <Button className='general-style padding32L padding32R pd-t-b-9' disabled={isSubmitting} isSubmitting={isSubmitting} onClick={handleApplicationSubmit} type='button'>
              Submit Assessment
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Assessment;
